var exports = {
  "P": "x28a7bf27--183d3c--marketing-page",
};

module.exports = exports;
